import { resolve } from '@/core/di';
import { PatientValidator } from './PatientValidator';
import { PublicPatientApi } from './PublicPatientApi';

export const api = (): PublicPatientApi => resolve(PublicPatientApi);
export const validator = (): PatientValidator => resolve(PatientValidator);
